import React from 'react';
import Header from './components/Header.js';
import Footer from './components/Footer.js';
import Home from './components/sections/Home.js';
import About from './components/sections/About.js';
import Portfolio from './components/sections/Portfolio.js';
import Services from './components/sections/Services.js';
import Events from './components/sections/Events.js';
import Pricing from './components/sections/Pricing.js';
import Testimonials from './components/sections/Testimonials.js';
import Contact from './components/sections/Contact.js';
import './index.css';

function App() {
  return (
    <div className="App">
      <Header />
      <main>
        <Home />
        <About />
        <Portfolio />
        <Services />
        <Events />
        <Pricing />
        <Testimonials />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}

export default App;
